import React from 'react';
import Route from 'react-router/lib/Route';
import SettlementReport from '.';

import { requireSettlementReportAllowed } from './utils';

const Routes = store => (
  <Route
    path="settlement"
    onEnter={requireSettlementReportAllowed(store)}
    component={SettlementReport}
  />
);

export default Routes;
